import { RequestService } from '~/services/RequestService'
import { Form } from '~/shared/api'
import { SaveUnifiedProfilePayload, UnifiedProfileModel } from '~/model/UnifiedProfile'

class SaveUnifiedProfileForm extends Form {
  constructor(payload: Omit<SaveUnifiedProfilePayload, 'photo'>, photo: File) {
    super()
    Object.assign(this, payload, { photo })
    this.setSendAs('form-data')
  }
}

export class UnifiedProfileService {
  // eslint-disable-next-line no-useless-constructor
  constructor(private requestService: RequestService) {}

  readonly url = '/api/v1/yavagro/profile-resume/'

  public async getUnifiedProfile(): Promise<UnifiedProfileModel> {
    const res = await this.requestService.request<{ data: UnifiedProfileModel }>({ url: this.url })
    return new UnifiedProfileModel(res.data.data)
  }

  public async saveUnifiedProfile(payload: SaveUnifiedProfilePayload): Promise<void> {
    const { photo, ...rest } = payload

    if (!(photo instanceof File)) {
      await this.requestService.request({ url: this.url, method: 'POST', data: rest, _silent: true })
      return
    }

    await this.requestService.request({
      url: this.url,
      method: 'POST',
      data: new SaveUnifiedProfileForm(rest, photo).serialize(),
      headers: { 'Content-Type': 'multipart/form-data' },
      _silent: true
    })
  }
}
